import type { TTipoProdutoChileEnum, TTipoProdutoPrecificadoBrasilEnum } from '@/types/produto'
import type { TTipoAmortizacaoEnum } from '@/types/simulacao'

export const produtosKeys = {
  produtos: ['produtos'] as const,
  status: (idExternoProduto: number) => [...produtosKeys.produtos, 'status', idExternoProduto] as const,
  listas: () => [...produtosKeys.produtos, 'listas'] as const,
  lista: (filtros: {
    idExternoBloco: number
    tipoProduto: TTipoProdutoPrecificadoBrasilEnum
    isVagaPadrao?: boolean
  }) => [...produtosKeys.produtos, { filtros }, 'lista'] as const,
  disponiveis: (
    idExternoBloco: number,
    tipoProduto: TTipoProdutoPrecificadoBrasilEnum | TTipoProdutoChileEnum,
    simulacaoId: string,
  ) => [...produtosKeys.produtos, idExternoBloco, tipoProduto, simulacaoId, 'disponiveis'] as const,
  acessoriosDisponiveis: (idExternoBloco: number, simulacaoId: string) =>
    [...produtosKeys.produtos, idExternoBloco, simulacaoId, 'acessoriosDisponiveis'] as const,
  detalhes: () => [...produtosKeys.produtos, 'detalhes'] as const,
  detalhe: (id: number) => [...produtosKeys.detalhes(), id] as const,
  detalheUnidade: (id: number) => [...produtosKeys.detalhe(id), 'unidades'] as const,
  detalheAcessorio: (id: number) => [...produtosKeys.detalhe(id), 'acessorios'] as const,
  detalheVagaPadrao: (id: number) => [...produtosKeys.detalhe(id), 'vaga-padrao'] as const,
  detalheLote: (id: number) => [...produtosKeys.detalhe(id), 'lotes'] as const,
  configuracoesDePrecos: () => [...produtosKeys.produtos, 'configuracao-de-preco'] as const,
  configuracaoDePreco: (
    idExternoProduto: number,
    idExternoBloco: number,
    tipoDeAmortizacao?: TTipoAmortizacaoEnum | null,
  ) => [...produtosKeys.configuracoesDePrecos(), idExternoProduto, idExternoBloco, tipoDeAmortizacao] as const,
  novaSimulacao: (idExternoProduto: number) => [...produtosKeys.produtos, idExternoProduto] as const,
  novaSimulacaoEmpreendimento: (
    idExternoEmpreendimento: number,
    tipoDoProduto: TTipoProdutoPrecificadoBrasilEnum | TTipoProdutoChileEnum,
  ) => [...produtosKeys.produtos, 'nova-simulacao-empreendimento', idExternoEmpreendimento, tipoDoProduto] as const,
  lotesEmpreendimento: (idExternoEmpreendimento: string) =>
    [...produtosKeys.produtos, 'lotes-empreendimento', idExternoEmpreendimento] as const,
  reservaProduto: () => [...produtosKeys.produtos, 'reserva-produto'] as const,
}
